// i18n area 'tasks' — locale pl-PL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.pl-PL.meta.json.
import type { enUS } from './tasks'

export const plPL: typeof enUS = {
  macrotasks: {
    title: 'Makrotaski',
    subtitle: 'Operacje złożone — można je wznowić od nieudanego kroku albo anulować',
    colType: 'Typ',
    colTarget: 'Obiekt',
    colPhase: 'Faza',
    colSteps: 'Kroki',
    empty: 'Brak makrotasków',
    detail: 'Szczegóły',
    failedAt: 'błąd na kroku',
    resume: 'Ponów od nieudanego kroku',
    abort: 'Przerwij wszystko',
    cancel: 'Anuluj',
    actionError: 'Akcja została odrzucona'
  },
  tasks: {
    title: 'Taski',
    searchPlaceholder: 'Szukaj według typu lub targetu',
    type: 'Typ',
    target: 'Target',
    phaseLabel: 'Faza',
    progress: 'Postęp',
    started: 'Rozpoczęto',
    finished: 'Zakończono',
    node: 'Węzeł',
    empty: 'Brak tasków',
    loadError: 'Nie można wczytać tasków — czy backend TVirt jest osiągalny?',
    limboHint: "Węzeł '{node}' jest nieosiągalny od {time} — task trzyma write lease na swoim targecie, dopóki węzeł nie wróci albo nie zostanie potwierdzony jako wyłączony",
    nodeAttested: 'Węzeł potwierdzony jako wyłączony',
    phase: {
      queued: 'W kolejce',
      running: 'W trakcie',
      succeeded: 'Ukończony',
      failed: 'Nieudany',
      cancelled: 'Anulowany',
      'failed-at-step': 'Niepowodzenie na kroku',
      aborted: 'Przerwany'
    },
    dropdown: {
      tooltip: 'Taski w toku',
      title: 'Taski w toku',
      empty: 'Brak tasków w toku',
      viewAll: 'Zobacz wszystkie taski'
    },
    detail: {
      open: 'Szczegóły',
      scope: 'Scope',
      message: 'Komunikat',
      params: 'Parametry',
      result: 'Wynik',
      errorTitle: 'Błąd',
      steps: 'Kroki',
      failedAt: 'błąd na kroku',
      superseded: 'zastąpiony',

      // Standardowy dialog (round #156): miejsce podrzędnego taska w planie
      // nadrzędnego, sam task nadrzędny (otwierany w miejscu) i krok, który zawiódł.
      step: 'Krok',
      parent: 'Task nadrzędny',
      failedStep: 'Nieudany krok',
      log: 'Log',
      logEmpty: 'Brak wierszy logu',
      close: 'Zamknij'
    },
    actions: {
      cancel: 'Anuluj',
      resume: 'Ponów od nieudanego kroku',
      abort: 'Przerwij wszystko (cofnięcie wykonanych kroków)',
      refused: 'Akcja została odrzucona'
    }
  },
  events: {
    loadError: 'Nie udało się wczytać dziennika — czy backend TVirt jest osiągalny?',
    title: 'Zdarzenia',
    subtitle: 'Pamięć historyczna klastra: fakty dokonane, od najnowszych',
    filterSeverity: 'Waga',
    filterCategory: 'Kategoria',
    filterAll: 'Wszystkie',
    searchLabel: 'Szukaj',
    searchPlaceholder: 'Szukaj w całym dzienniku',
    subjectFilter: 'Zdarzenia obiektu {subject} — pokaż wszystkie',
    colAt: 'Kiedy',
    colSeverity: 'Waga',
    colType: 'Typ',
    colSubject: 'Podmiot',
    colActor: 'Kto',
    colNode: 'Node',
    colMessage: 'Komunikat',
    empty: 'Brak zdarzeń',
    loadMore: 'Wczytaj więcej',
    actorSystem: 'system',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'ID zdarzenia',
    taskCollectedHint: 'Task ma krótszą retencję: po jego zebraniu odnośnik przestaje odpowiadać',
    severity: {
      info: 'Informacja',
      warning: 'Ostrzeżenie',
      error: 'Błąd',
      critical: 'Krytyczne'
    },
    category: {
      lifecycle: 'Cykl życia',
      config: 'Konfiguracja',
      availability: 'Dostępność',
      security: 'Bezpieczeństwo'
    },
    type: {
      haNetsvcFailedOver: 'Failover usługi sieciowej',
      haNetsvcNoCandidate: 'Usługa sieciowa bez węzła kandydata',
      haNetsvcReaped: 'Instancja lokalna zebrana przy powrocie',
      netsvcFloatipMoved: 'Pływające IP przeniesione do innego posiadacza',
      netsvcFloatipNoHolder: 'Pływające IP bez zdrowego celu',
      haAppFailedOver: 'Failover instancji App',
      haAppNoCandidate: 'Instancja App bez węzła kandydata',
      haAppStorageLocalSkip: 'Instancja App nieprzeniesiona: dane trwałe lokalne na martwym węźle',
      haAppReaped: 'Lokalny pod instancji App zżęty przy powrocie'
    }
  },
  audit: {
    loadError: 'Nie udało się wczytać rejestru audytu — czy backend TVirt jest osiągalny?',
    title: 'Audyt',
    subtitle: 'Kto co zrobił, kiedy i na jakim obiekcie — próby działań, wraz z odmowami',
    filterOutcome: 'Wynik',
    filterAll: 'Wszystkie',
    filterSudo: 'Tylko działania podwyższone',
    colAt: 'Kiedy',
    colActor: 'Kto',
    colAction: 'Działanie',
    colTarget: 'Obiekt',
    colOutcome: 'Wynik',
    colNode: 'Node',
    empty: 'Brak zapisanych działań',
    loadMore: 'Wczytaj więcej',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Trasa',
    detailProblem: 'Powód',
    detailTask: 'Task',
    detailClientIp: 'Skąd',
    detailId: 'ID rekordu',
    detailSession: 'Sesja',
    taskHint: 'Wynik przyjętego działania żyje w dzienniku zdarzeń, pod tym samym id taska',
    outcome: {
      succeeded: 'Udane',
      accepted: 'Przyjęte',
      denied: 'Odmówione',
      rejected: 'Odrzucone',
      failed: 'Nieudane'
    }
  },
  notifications: {
    loadError: 'Nie udało się wczytać powiadomień — czy backend TVirt jest osiągalny?',
    actionError: 'Akcja została odrzucona',
    title: 'Powiadomienia',
    subtitle: 'Miejsca docelowe, do których fakty dziennika opuszczają klaster',
    rulesTitle: 'Reguły',
    rulesSubtitle: 'Które fakty wychodzą i dokąd',
    deliveriesTitle: 'Dostarczenia',
    deliveriesSubtitle: 'Wynik każdego powiadomienia, wraz z przyczyną gdy się nie powiedzie',
    colName: 'Nazwa',
    colKind: 'Typ',
    colWhere: 'Dokąd',
    colScope: 'Scope',
    colSeverity: 'Waga',
    colMatch: 'Filtr',
    colTargets: 'Cel',
    colAt: 'Kiedy',
    colState: 'Stan',
    colEvent: 'Zdarzenie',
    colAttempts: 'Próby',
    colOutcome: 'Wynik',
    empty: 'Brak wierszy',
    matchAll: 'wszystkie fakty',
    test: 'Testuj',
    testOk: 'Powiadomienie testowe dostarczone do {target}',
    testFailed: 'Test do {target} nie powiódł się: {reason}',
    retry: 'Ponów w kolejce',
    retried: 'Dostarczenie ponowione w kolejce',
    grouped: 'i {count} kolejnych powtórzeń',
    state: {
      failed: 'Nieudana',
      pending: 'W kolejce',
      sending: 'Wysyłanie',
      sent: 'Wysłana'
    },
    tabTargets: 'Miejsca docelowe',
    tabRules: 'Reguły',
    tabDeliveries: 'Dostawy',
    targetCreateTitle: 'Nowe miejsce docelowe',
    ruleCreateTitle: 'Nowa reguła',
    nameHint: 'Małe litery, cyfry i myślniki; unikalne w zakresie',
    kindImmutableHint: 'Niezmienne: zmiana typu oznacza utworzenie innego miejsca docelowego',
    kindSmtp: 'Poczta (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Stan',
    enabledOn: 'Aktywne',
    enabledOff: 'Wstrzymane',
    smtpHost: 'Serwer SMTP',
    smtpPort: 'Port',
    smtpPortHint: 'Zwykle: 25 bez TLS, 587 ze starttls, 465 z tls',
    smtpSecurity: 'Bezpieczeństwo',
    smtpFrom: 'Nadawca',
    smtpTo: 'Odbiorcy',
    smtpToHint: 'Jeden lub więcej adresów rozdzielonych przecinkami',
    webhookUrl: 'URL',
    payload: 'Zawartość',
    payloadHint: 'Przy minimal komunikat i dane zdarzenia nie opuszczają klastra',
    credential: 'Poświadczenie',
    credentialNone: 'Brak',
    credentialHintSmtp: 'Konto przekaźnika z magazynu kluczy; brak oznacza anonimowe SMTP',
    credentialHintWebhook: 'Sekret podpisu z magazynu kluczy; bez podpisu każdy, kto zna URL, może podać się za klaster',
    minSeverityHint: 'Próg, nie zbiór: od tej wagi w górę',
    categories: 'Kategorie',
    categoriesHint: 'Puste = wszystkie',
    types: 'Typy zdarzeń',
    typesHint: 'Rozdzielone przecinkami; puste = wszystkie. Nieznany typ jest odrzucany',
    targetsHint: 'Co najmniej jedno; muszą znajdować się w zakresie reguły lub w jego przodku',
    recursiveOn: 'Także zakresy potomne',
    recursiveOff: 'Tylko ten zakres',
    recursiveHint: 'Zasoby żyją w liściach: bez potomków reguła na korzeniu powiadamia prawie o niczym',
    repeatWindow: 'Okno grupowania (s)',
    repeatWindowHint: 'W oknie powtórzenia nie wysyłają poczty: są liczone przy pierwszym. 0 wyłącza',
    targetInUseError: 'Miejsce docelowe {name} jest jeszcze używane przez regułę'
  }
}
